export const CHANGE_QUERY_DATES = 'CHANGE_QUERY_DATES';
export const CHANGE_COMPARISON_DATES = 'CHANGE_COMPARISON_DATES';
export const CHANGE_SPLIT_BY_DEMOGRAPHICS = 'CHANGE_SPLIT_BY_DEMOGRAPHICS';
export const DOWNLOAD_CSV_BUTTON = 'DOWNLOAD_CSV_BUTTON';
export const DOWNLOAD_CSV_BY_DAY_BUTTON = 'DOWNLOAD_CSV_BY_DAY_BUTTON';
export const CHANGE_METRICS = 'CHANGE_METRICS';
export const ENTER_PAGE = 'ENTER_PAGE';
export const ANALYTICS_QUERY = 'ANALYTICS_QUERY';
export const CLICK = 'CLICK';
